// @core/api/endpoints/task/assign_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AssignEntityRequest,
  TaskLifecycleResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Assign entity
 * Assigns any task-aware entity to an actor. The assignee is notified and the entity appears in their task list.
 */
export async function AssignEntity(
  target_type: string,
  target_id: string,
  data: AssignEntityRequest,
  options?: RequestOptions
): Promise<TaskLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:target_type/:target_id/assign`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<TaskLifecycleResponse>(requestPath, data, requestOptions);
}
